//OCRAPI
import request from '@/utils/request/index'
import * as ApiType from './type'
import { _c } from '@/utils'
import { OCR } from './type'
import { PageReqSchema } from '@/types/axios/public-json-structure'
const isMock = false

// 创建任务记录
export function createOCRTaskAPI(type: string, fileIds: string[], languages: string, ) {
  return request({
    method: 'post',
    url: _c('/api/ocr/create',isMock),
    data: { type, languages, fileIds},
    showMessageOnError: false,
  })

}
// 查询识别进度
export function getOcrProgressApi(id: string) {
  return request.get<ApiType.OCR.OCRLoopRes>(_c('/api/ocr/progress',isMock), {
    params: {id: id},
    showMessageOnError: false,
  })
}


//删除/批量删除
export function delOcrApi(ids?: string[]) {
  return request.delete(_c(`/api/ocr/delete`,isMock),{ data: ids })
}
//导出/批量导出
export function downloadOcrApi(ids?: string[]){
  return request({
    method: 'post',
    url: _c('/api/ocr/export', isMock),
    responseType: 'blob',
    data: ids,
    showMessageOnError: false,
  })
}
//重试
export function createOCRretryAPI(id: string) {
  return request.get(_c(`/api/ocr/retry`, isMock), {
    params: {id:id}
  })
}

// 查询OCR识别任务结果详情
export const getResultAPI = (id: string) => {
  return request.get<ApiType.OcrResult.Res>(`/api/ocr/detail?id=${id}`)
}

// 修改OCR识别任务结果
export const updateResultAPI = (data: ApiType.OcrResult.IReq) => {
  return request.post(`/api/ocr/save`, data)
}

// OCR结果分页列表
export const getOcrResultList = (params:PageReqSchema) => {
  return request.get<OCR.OCRListRes[]>('/api/ocr/page', { params })
}

// 获取识别模版
export const getOcrPropertyApi = () => {
  return request.get<OCR.PropertyItem[]>('/api/ocr/property')
}


